import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .text_r {\n    font-size: 24px;\n    font-weight: bold;\n    color: ",
        ";\n    margin-bottom: 36px;\n\n    @media (max-width: 1200px) {\n      font-size: 20px;\n      margin-bottom: 24px;\n    }\n    @media (max-width: 768px) {\n      font-size: 18px;\n      margin-bottom: 16px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 48px;\n\n  @media (max-width: 1200px) {\n    margin-bottom: 36px;\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 24px;\n  }\n\n  .ant-row {\n    .ant-col {\n      .ant-form-item-control-input {\n        .ant-form-item-control-input-content {\n          .ant-input-affix-wrapper {\n            padding: 0;\n            border: 0;\n            border-radius: 0;\n            border-bottom: solid 2px #1b1b29;\n\n            &.ant-input-affix-wrapper-focused {\n              border-color: ",
        ";\n            }\n          }\n\n          .ant-input {\n            font-size: 24px;\n            font-weight: bold;\n            color: ",
        ";\n            text-align: center;\n            padding: 16px 0;\n            border: 0;\n          }\n\n          @media (max-width: 1200px) {\n            .ant-input {\n              font-size: 20px;\n              padding: 8px 0;\n            }\n          }\n          @media (max-width: 768px) {\n            .ant-input {\n              font-size: 16px;\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n          background: #002fa8 !important;\n\n          &:hover {\n            background: rgba(0, 47, 168, 0.9) !important;\n          }\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n          background-color: rgba(27, 27, 41, 0.3) !important;\n          pointer-events: none;\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: block;\n  width: 384px;\n  height: 56px;\n  padding: 0;\n  margin: 0 auto;\n  box-shadow: 0 4px 4px 0 rgba(27, 27, 41, 0.3);\n  border-radius: 0;\n  ",
        ";\n\n  span {\n    display: block;\n    font-size: 24px;\n    font-weight: bold;\n    color: #fff;\n    line-height: 54px;\n  }\n\n  @media (max-width: 1200px) {\n    width: 200px;\n\n    span {\n      font-size: 20px;\n    }\n  }\n  @media (max-width: 768px) {\n    span {\n      font-size: 18px;\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { getError } from "@/components/Formik";
import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import { Form, FormItem, Input, SubmitButton } from "formik-antd";
import { Col, Row } from "antd";
import { themeGet } from "@styled-system/theme-get";
import { suffix } from "@/components/Suffix";
const StyledForm = styled(Form).withConfig({
    componentId: "sc-f70aaece-0"
})(_templateObject(), themeGet("text.0", "#1B1B29"));
const StyledFormItem = styled(FormItem).withConfig({
    componentId: "sc-f70aaece-1"
})(_templateObject1(), themeGet("primary.0", "#002FA8"), themeGet("text.0", "#1B1B29"));
const StyledSubmitButton = styled(SubmitButton).withConfig({
    componentId: "sc-f70aaece-2"
})(_templateObject4(), (props)=>props.clickable ? css(_templateObject2()) : css(_templateObject3()));
export const TrackingNumberFormSchema = Yup.object().shape({
});
const TrackingNumberFormWrapper = styled.div.withConfig({
    componentId: "sc-f70aaece-3"
})(_templateObject5());
export const TrackingNumberForm = (param)=>{
    let { name , onSubmit , forwardRef , initialStatus , initialValues , title  } = param;
    return /*#__PURE__*/ _jsx(TrackingNumberFormWrapper, {
        children: /*#__PURE__*/ _jsx(Formik, {
            innerRef: (instance)=>{
                if (forwardRef) {
                    forwardRef.current = instance;
                }
            },
            validationSchema: TrackingNumberFormSchema,
            onSubmit: onSubmit,
            initialValues: initialValues,
            initialStatus: initialStatus,
            children: (param)=>{
                let { handleChange , handleBlur , touched , errors , isValid , handleSubmit , setValues , values , isSubmitting , status  } = param;
                const emailError = getError("email", {
                    touched,
                    errors,
                    status
                });
                const descriptionError = getError("description", {
                    touched,
                    errors,
                    status
                });
                ;
                return /*#__PURE__*/ _jsxs(StyledForm, {
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text_r",
                            children: title
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "number1",
                                        required: true,
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            onChange: handleChange("number1"),
                                            autoFocus: true,
                                            onBlur: handleBlur("number1"),
                                            name: "number1",
                                            placeholder: "2204",
                                            maxLength: 4,
                                            suffix: suffix
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "number2",
                                        required: true,
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            onChange: handleChange("number2"),
                                            autoFocus: true,
                                            onBlur: handleBlur("number2"),
                                            name: "number2",
                                            placeholder: "NETB",
                                            maxLength: 4,
                                            suffix: suffix
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "number3",
                                        required: true,
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            onChange: handleChange("number3"),
                                            autoFocus: true,
                                            onBlur: handleBlur("number3"),
                                            name: "number3",
                                            placeholder: "EN009",
                                            maxLength: 5,
                                            suffix: suffix
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "number4",
                                        required: true,
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            onChange: handleChange("number4"),
                                            autoFocus: true,
                                            onBlur: handleBlur("number4"),
                                            name: "number4",
                                            placeholder: "0710",
                                            maxLength: 4,
                                            suffix: suffix
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(StyledSubmitButton, {
                            disabled: !isValid || isSubmitting,
                            onSubmit: handleSubmit,
                            loading: isSubmitting,
                            clickable: values.number1.length === 4 && values.number2.length === 4 && values.number3.length === 5 && values.number4.length === 4,
                            children: "조회"
                        })
                    ]
                });
            }
        })
    });
};
